/**
 * Checks if the country is part of the European Union
 */
export function isEUCountry(countryCode: string): boolean {
	const EUCountries: string[] = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];

	if (EUCountries.includes(countryCode)) {
		return true;
	}

	return false;
}
